<template>
  <l-layout>
    <info-card
      :item="reservation"
      :opts="opts"
      :sub-title="TYPE_TEXT[reservation.type]"
      title="plate"
    >
      <slot name="title-actions" slot="title-actions"></slot>
      <template slot="append">
        <!--Fixme 相应逻辑未补全-->
        <v-subheader>通行规则</v-subheader>
        <l-pass-rule-list :pass-rules="rules"></l-pass-rule-list>
        <v-subheader v-if="authority.editPrompt">通行提示</v-subheader>
        <v-layout class="mb-4" v-if="authority.editPrompt" wrap>
          <v-flex :class="opt.layout" :key="opt.key" v-for="opt in promptDefine">
            <info-cell v-bind="opt" v-model="group[opt.key]"></info-cell>
          </v-flex>
        </v-layout>
        <v-subheader v-if="specifics.length">特殊规则</v-subheader>
        <l-pass-rule-list :pass-rules="specifics" v-if="specifics.length"></l-pass-rule-list>
        <div class="py-2"></div>
        <person-info-card :person="reservation.visitor" flat subheader="来访人"></person-info-card>
        <person-info-card :person="reservation.owner" flat subheader="联系人"></person-info-card>
        <person-info-card :person="reservation.applicant" flat subheader="申请人"></person-info-card>
        <l-data-table
          class="mt-5"
          :headers="headers"
          :get-data-func="getPassLogs"
          no-data-text="没有通行记录"
          clickable
          title-text="通行日志"
          hide-title-search
          :init-pagination="{sortBy: 'passDatetime', descending: true}"
          flat
        >
          <template slot="title">
            <v-subheader>预约通行记录</v-subheader>
          </template>
        </l-data-table>
      </template>
    </info-card>
  </l-layout>
</template>

<script>
import InfoCard from '../../../components/infoCard'
import LPassRuleList from '../../../components/LPassRuleList'
import PersonInfoCard from '../../../components/personInfoCard'
import {Reservation, PassRule} from '@/object'
import InfoCell from '../../../components/infoCell'

export default {
  name: 'PersonReservationInfo',
  components: {InfoCell, PersonInfoCard, LPassRuleList, InfoCard},
  props: {
    authority: {type: Object, required: true},
    reservation: {type: Object, default: () => new Reservation()}
  },
  data () {
    return {
      group: {},
      headers: [
        {text: '通行时间', value: 'passDatetime', align: 'right', placeholder: 'N/A'},
        {text: '通行园区', value: 'parkingLotName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '通行关口', value: 'controllerName', align: 'right', placeholder: 'N/A', sortable: false},
        {
          text: '是否放行',
          value: 'status',
          align: 'right',
          placeholder: 'N/A',
          f: v => v + '' === '1' ? '抬杆放行' : '禁止通行'
        },
        {text: '通行详情', value: 'details', align: 'right', placeholder: 'N/A', tooltip: true, maxWidth: '14em'}
      ],
      promptDefine: [
        {
          key: 'ledPromptIn',
          label: '进场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led'
        },
        {
          key: 'audioPromptIn',
          label: '进场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio'
        },
        {
          key: 'ledPromptOut',
          label: '出场屏显提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.led'
        },
        {
          key: 'audioPromptOut',
          label: '出场语音提示',
          layout: ['xs12'],
          textarea: true,
          icon: '$vuetify.icons.audio'
        }
      ],
      TYPE_TEXT: {
        [Reservation.ADMIN]: '高级预约',
        [Reservation.ORG]: '单位预约',
        [Reservation.PERSONAL]: '个人预约',
        [Reservation.LETTER]: '函件预约'
      },
      rules: [],
      specifics: [],
      opts: [
        {
          key: 'startDatetime',
          label: '开始时间',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.datetime',
          f: v => this.$L.time.stringify(v)
        },
        {
          key: 'endDatetime',
          label: '结束时间',
          layout: ['xs12', 'sm4'],
          icon: '$vuetify.icons.datetime',
          f: v => this.$L.time.stringify(v)
        },
        {
          key: 'description',
          label: '备注',
          textarea: true,
          layout: ['xs12'],
          icon: '$vuetify.icons.description'
        }
      ]
    }
  },
  methods: {
    async getGroup () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('personPassControl/getGroups', {
          search: {key: 'id', value: this.reservation.groupId},
          pagination: {page: 1, rowsPerPage: 100}
        })
        if (items.length) {
          this.group = items[0]
        }
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    getPassLogs ({pagination, sortStack, filterItems, search}) {
      console.log('filter', this.reservation)
      return this.$store.dispatch('personPassControl/getLogs', {
        pagination,
        sortStack,
        filter: {
          creationTime: {
            key: 'creationTime',
            value: [
              Number(this.reservation.startDatetime) || 0,
              Number(this.reservation.endDatetime) || 9999999999999
            ],
            range: true
          }
        },
        search: {key: 'plate', value: this.reservation.plate}
      })
    },
    async getRules () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('personReservation/getRules', {
          groupId: this.reservation.groupId,
          pagination: {page: 1, rowsPerPage: 100}
        })
        this.rules = items
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    },
    async getSpecifics () {
      try {
        // Fixme 需要从页面上支持分页
        let {items} = await this.$store.dispatch('personReservation/getSpecifics', {
          vehicle: this.reservation.vehicle,
          pagination: {page: 1, rowsPerPage: 100}
        })
        // console.log('get specifcs', items)
        this.specifics = items
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
    }
  },
  created () {
    this.getRules()
    this.getSpecifics()
    this.getGroup()
  }
}
</script>

<style scoped>

</style>
